export const c_dual_list_selector_GridTemplateColumns_pane_MinMax_max = {
  "name": "--pf-c-dual-list-selector--GridTemplateColumns--pane--MinMax--max",
  "value": "28.125rem",
  "var": "var(--pf-c-dual-list-selector--GridTemplateColumns--pane--MinMax--max)"
};
export default c_dual_list_selector_GridTemplateColumns_pane_MinMax_max;